<script>
import BarList from '../components/bar-list'
import TabpreForm from './tabpre-form'
import TabpreItensForm from './tabpre-itens-form'
import { getText, formatDate } from '../shared/utils'
import { SysVars } from '../main'

export default {
    data () {
        return {
            showForm: 'list',  //list, itens, form
            crud: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            tabelasList: [],
            codtabpre: null,
            isView: false,
            title: '',
            indexEdit: null,
            showInserirProduto: false,
        }
    },

    computed: {
        possuiPermissao: function () {
            if (SysVars.usaIntegracao) {
              return false;
            }
            return SysVars.appNFe || SysVars.appERP || SysVars.appLoja || (SysVars.usuarioAdministrador && SysVars.appForcaVendas) 
        },

        tabpreList: function () {
            return this.$store.getters.getTabpreList
        },

        selectedTabpre: function () {
            let self = this
            let tabela = this.tabpreList.filter(obj => {
                return obj.codtabpre == self.codtabpre
            })
            return tabela[0]
        },
    },

    filters: {
        getTipoTabela (value) {
            if (value == 'P') 
                return 'Tabela de preços normal com preços digitados'
            else if (value == 'D')
                return 'Tabela automática de desconto aplicado na tabela de preços padrão'
            else if (value == 'A')
                return 'Tabela automática de acréscimo aplicado na tabela de preços padrão'
        }
    },

    watch: {
        codtabpre: function () {
            this.showInserirProduto = false
            let self = this
            let tabela = this.tabpreList.filter(obj => {
                return obj.codtabpre == self.codtabpre
            })
            if (tabela.length > 0) {
                this.title = tabela[0].descricao
            }
            if (this.codtabpre) {
                this.loadData()
            }
        },
    },

    methods: {
        handleEdit (cod) {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.')
                return
            }
            this.crud = SysVars.crudU;
            this.codtabpre = cod
            this.showForm = 'form';
        },
        
        handleNew () {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.')
                return
            }
 
            this.crud = SysVars.crudI
            this.showForm = 'form';
        },

        handleEditItens (cod) {
            this.codtabpre = cod
            this.showForm = 'itens';
        },
        
        closeForm(codtabpre) {
            this.showForm = 'list'
            this.loadData()
            if (!codtabpre) {
                return
            }
            this.codtabpre = codtabpre
            let self = this
            setTimeout(function() {
                self.showForm = 'itens'
            }, 500)

        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtabpre":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        async loadTabelas (param) {
            //carrega lista de tabelas cadastradas no combo
            await this.$store.dispatch('loadTabpre', {})
            if (this.$store.getters.getTabpreList) {
                this.tabelasList = this.$store.getters.getTabpreList.map(function (obj) {
                    return { id: obj.codtabpre, text: obj.descricao }
                })
                if (this.$store.getters.getTabpreList.length > 0) {
                    if (param) {
                        this.codtabpre = param
                    } 
                    if (!this.codtabpre) {
                        this.codtabpre = this.$store.getters.getTabpreList[0].codtabpre
                    }
                }
            }

        },

        textST (value) {
            return getText(value, this.metadata.tabpre.sttabpre)
        },


        loadData() {
            this.$store.dispatch('loadTabpre', { filter: this.filter } )
            this.offset = ''
        },

    },

    components: {
        BarList, TabpreForm, TabpreItensForm
    },

    created () {
        this.loadTabelas()
    },

}

</script>

<template>
    <div>
        <div v-if="showForm == 'list'" id="list"> 
            <bar-list
                :refresh-button="true" 
                :new-button="possuiPermissao" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Tabela de Preço" 
                plural-entity="Tabelas de Preço"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela descrição">
            </bar-list>

            <div class="default-container nb-card-list">
                <alert v-if="tabpreList.length == 0" type="info" title="" text="Nenhuma tabela cadastrada."></alert>

                <article class="nb-card" v-for="(tabpre, index) in tabpreList" :key="tabpre.codtabpre || index">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-dollar" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ tabpre.descricao }}</h2>
                                    <span v-if="tabpre.sttabpre == 'I'" class="nb-card-badge nb-card-badge--inactive">
                                        {{ textST(tabpre.sttabpre) }}
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="tabpre.codtabpre">
                                    Código <strong>{{ tabpre.codtabpre }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="handleEditItens(tabpre.codtabpre)">
                                <i class="fa fa-archive fa-fw"></i> <span class="d-none d-sm-inline ml-1">Produtos</span>
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-secondary" v-if="possuiPermissao" @click="handleEdit(tabpre.codtabpre)" title="Alterar">
                                <i class="fa fa-pencil fa-fw"></i>
                            </button>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail">
                            <span class="nb-card-detail-label">Tipo de Tabela</span>
                            <strong>{{ tabpre.tptabela | getTipoTabela(metadata.tabpre.tptabela) }}</strong>
                        </div>
                        <div class="nb-card-detail nb-card-detail--full" v-if="tabpre.texto">
                            <span class="nb-card-detail-label">Observações</span>
                            <strong>{{ tabpre.texto }}</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <tabpre-form v-if="showForm == 'form'" :index="codtabpre" :crud="crud" @closeform="closeForm"></tabpre-form>
        <tabpre-itens-form v-if="showForm == 'itens'" :tabpre="selectedTabpre" @closeform="closeForm"></tabpre-itens-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--inactive {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.nb-card-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

.nb-card-actions .btn {
  border-radius: 6px;
}

.nb-card-actions .btn-outline-primary {
  color: #004e94;
  border-color: #004e94;
}

.nb-card-actions .btn-outline-primary:hover {
  color: #fff;
  background-color: #004e94;
}

.nb-card-actions .btn-outline-secondary {
  color: #475569;
  border-color: #cbd5e1;
}

.nb-card-actions .btn-outline-secondary:hover {
  color: #0f172a;
  background: #f1f5f9;
  border-color: #94a3b8;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail--full {
  grid-column: 1 / -1;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    grid-template-columns: minmax(0, 1fr);
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/tabpre-list.vue